import { render } from "./ElementSelection.vue?vue&type=template&id=5d138780&scoped=true&ts=true"
import script from "./ElementSelection.vue?vue&type=script&lang=ts"
export * from "./ElementSelection.vue?vue&type=script&lang=ts"

import "./ElementSelection.vue?vue&type=style&index=0&id=5d138780&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d138780"]])

export default __exports__